import styles from './Notification.module.css';
import { notificationActions } from '../../store/notification/notification-slice';
import { useDispatch } from 'react-redux';

const Notification = (props) => {
  const dispatch = useDispatch();
  let secondaryClass = '';

  if (props.status === 'error') {
    secondaryClass = styles.error;
  } else if (props.status === 'success') {
    secondaryClass = styles.success;
  }

  const onClickHandler = () => {
    dispatch(notificationActions.clearNotification());
  }

  return (
    <section className={`${styles.notification} ${secondaryClass}`} onClick={onClickHandler}>
      <p>{props.message}</p>
    </section>
  );
}

export default Notification;